const apiBaseUrl =
  import.meta.env.VITE_API_BASE_URL ?? 'https://uat.mutu.solutions/gateway';

export type ConfigProps = {
  Sidebar_drawer: boolean;
  apiBaseUrl: string;
  apiUrl: string;
  appEnv: string;
  isProduction: boolean;
  company: {
    code: string;
    defaultCompanyCode: string;
    companies: { code: string; name: string }[];
  };
  storageKeys: {
    authToken: string;
    refreshToken: string;
    userData: string;
    companyLogo: string;
  };
  companyCode: string;
};

const config: ConfigProps = {
  Sidebar_drawer: true,
  apiBaseUrl,
  apiUrl: apiBaseUrl,
  appEnv: import.meta.env.VITE_APP_ENV ?? import.meta.env.MODE,
  isProduction: import.meta.env.PROD,  company: {
    code: "INNTRI",
    defaultCompanyCode: "BNST",
    companies: [
      { code: "BNST", name: "Company BNST" },
      { code: "INNTRI", name: "Company INNTRI" },
    ],
  },
  storageKeys: {
    authToken: "auth_token",
    refreshToken: "refresh_token",
    userData: "user_data",
    companyLogo: "company_logo",
  },
  companyCode: "BNST",
};

export default config;
